"use client";

import type { ComponentInfo } from "@builder.io/sdk-react";

export const STICKS_PRODUCT_DETAILS_CONTAINER_INPUTS = [
  {
    name: "hasBadge",
    type: "boolean",
  },
  {
    name: "overwriteBadgeText",
    type: "string",
  },
  {
    name: "hasDiscountBadge",
    type: "boolean",
  },
  {
    name: "hasStrikethroughPrice",
    type: "boolean",
  },
  {
    name: "hideCta",
    type: "boolean",
  },
  {
    name: "hidePrice",
    type: "boolean",
  },
  {
    name: "productCta",
    type: "object",
    helperText:
      "Product CTA for not in stock products and commerce disabled tenants. Overwrites default configuration from Commerce Global Settings.",
    subFields: [
      {
        name: "label",
        type: "string",
      },
      {
        name: "url",
        type: "url",
      },
    ],
    defaultValue: {
      label: "",
      url: "",
    },
  },
] as const satisfies ComponentInfo["inputs"];

export const STICKS_PRODUCT_DETAILS_CONTAINER_BINDINGS_INPUTS = [
  {
    name: "sku",
    type: "string",
  },
  {
    name: "badgeText",
    type: "string",
  },
  {
    name: "description",
    type: "string",
  },
  {
    name: "shortDescription",
    type: "string",
  },
  {
    name: "knowMoreUrl",
    type: "string",
  },
  {
    name: "multiPackDescription",
    type: "string",
  },
  {
    name: "productName",
    type: "string",
  },
  {
    name: "isCommerceDisabled",
    type: "boolean",
  },
  {
    name: "isMultiPackEnabled",
    type: "boolean",
  },
  {
    name: "multiPackName",
    type: "string",
  },
  {
    name: "multiPackProducts",
    type: "list",
  },
  {
    name: "customBuyCtaLabel",
    type: "string",
  },
  {
    name: "sticksMatrixData",
    type: "object",
    subFields: [
      {
        name: "single_packs",
        type: "object",
        subFields: [
          { name: "onetime", type: "list", required: true },
          { name: "subscription", type: "list", required: true },
        ],
        required: true,
      },
      {
        name: "cartons",
        type: "object",
        subFields: [
          { name: "onetime", type: "list", required: true },
          { name: "subscription", type: "list", required: true },
        ],
        required: true,
      },
      {
        name: "mix_n_match",
        type: "object",
        subFields: [
          { name: "onetime", type: "list", required: true },
          { name: "subscription", type: "list", required: true },
        ],
        required: true,
      },
    ],
  },
  {
    name: "isSubscriptionsEnabled",
    type: "boolean",
  },
] as const satisfies ComponentInfo["inputs"];

export const ALL_STICKS_PRODUCT_DETAILS_CONTAINER_INPUTS = [
  ...STICKS_PRODUCT_DETAILS_CONTAINER_INPUTS,
  ...STICKS_PRODUCT_DETAILS_CONTAINER_BINDINGS_INPUTS,
] as const satisfies ComponentInfo["inputs"];

export type SticksProductDetailsContainerProps = BuilderComponentProps<
  typeof ALL_STICKS_PRODUCT_DETAILS_CONTAINER_INPUTS
>;
